import type { Call } from './call-view';

// REST and Socket.IO deliberately use different historical field names.
// Normalize at the boundary; keep the raw aliases for older consumers.
export function normalizeCall(payload: unknown): Call | null {
  let candidate = payload;
  for (let depth = 0; depth < 4; depth++) {
    if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) return null;
    const row = candidate as Record<string, unknown>;
    const id = text(row.id) ?? text(row.call_id);
    if (id) return {
      ...row, id,
      caller_id: text(row.caller_id) ?? text(row.initiated_by),
      type: text(row.call_type) ?? text(row.type),
      started_at: text(row.started_at) ?? text(row.start_time),
      ended_at: text(row.ended_at) ?? text(row.end_time),
      duration_sec: typeof row.duration_sec === 'number' ? row.duration_sec : typeof row.duration === 'number' ? row.duration : undefined,
    } as Call;
    candidate = row.call ?? row.data;
  }
  return null;
}
function text(value: unknown) { return typeof value === 'string' && value.length ? value : undefined; }
export function normalizeCalls(payload: unknown): Call[] {
  if (Array.isArray(payload)) return payload.flatMap(value => { const call = normalizeCall(value); return call ? [call] : []; });
  if (payload && typeof payload === 'object' && 'data' in payload) return normalizeCalls(payload.data);
  const call = normalizeCall(payload);
  return call ? [call] : [];
}
export function isIncomingFor(call: Call, userId: string): boolean {
  if (!call.caller_id || call.caller_id === userId) return false;
  if (call.is_group_call) {
    const me = call.participants?.find(p => (p.user_id ?? p.userId) === userId);
    // A targeted ringing event has no roster; a REST snapshot does.
    return me ? me.status === 'connecting' && ['ringing', 'accepted'].includes(call.status ?? '') : call.status === 'ringing';
  }
  return call.status === 'ringing' && (!call.callee_id || call.callee_id === userId);
}
